import { z } from 'zod'

import { AdaptedMapSchema } from 'shared/api/common/schemas/templates/adaptedMap'
import { DescriptionSchema } from 'shared/api/common/schemas/templates/description'
import { FolderSchema } from 'shared/api/common/schemas/templates/folder'
import { MapSchema } from 'shared/api/common/schemas/templates/map'
import { SelectionSchema } from 'shared/api/common/schemas/templates/selection'

const CurrentVersionSchema = z.object({
  page_id: z.string(),
  is_pro: z.boolean(),
  base_page_name: z.string(),
  template_fields: z.array(z.string()),
  structure: z.array(z.string()),
  folders: z.array(FolderSchema),
  custom_fields: z.array(z.string()).or(z.record(z.string(), z.unknown())),
  is_ai_addon: z.boolean(),
})

const MainCurrentVersionSchema = CurrentVersionSchema.extend({
  map: MapSchema.optional(),
})

const AdaptedCurrentVersionSchema = CurrentVersionSchema.extend({
  map: AdaptedMapSchema.optional(),
  selection: SelectionSchema.optional(),
})

export const TemplateSchema = z.object({
  template_id: z.number(),
  title: z.string(),
  is_protected: z.boolean(),
  is_editable: z.boolean(),
  is_tracked: z.boolean(),
  flows_locked_status: z.record(z.string(), z.boolean()).optional().or(z.array(z.string())),
  description: DescriptionSchema.nullable(),
  is_shared: z.boolean(),
  share_hash: z.string().nullable(),
  share_link: z.string().nullable(),
  share_type: z.number(),
  current_version: MainCurrentVersionSchema,
  image: z.object({ avatar_url_100x100: z.string().nullable(), color: z.string() }),
  template_access_data: z.object({
    is_protected: z.boolean(),
    is_locked: z.boolean(),
    is_tracked: z.boolean(),
    is_owner: z.boolean(),
  }),
})

export const AdaptedTemplateSchema = TemplateSchema.extend({
  id: z.number(),
  isProtected: z.boolean(),
  isLocked: z.boolean(),
  isTracked: z.boolean(),
  flowsLockedStatus: z.record(z.string(), z.boolean()).optional(),
  current_version: AdaptedCurrentVersionSchema,
  isGeneratingLink: z.boolean().optional(),
})

export type Template = z.infer<typeof TemplateSchema>
export type AdaptedTemplate = z.infer<typeof AdaptedTemplateSchema>
export type AdaptedCurrentVersion = z.infer<typeof AdaptedCurrentVersionSchema>
